import React from 'react';
import { navigate } from 'gatsby';
import {
  HelpHeaderTitleStyled,
  HelpIconStyled,
} from './styles/HelpHeaderStyled';

const HelpHeader = () => {
  const goToHelp = () => {
    navigate('/ayuda');
  };

  return (
    <>
      <HelpIconStyled onClick={goToHelp} />
      <HelpHeaderTitleStyled onClick={goToHelp}>Ayuda</HelpHeaderTitleStyled>
    </>
  );
};

export default HelpHeader;
